import styled, { css } from "styled-components";

export const Backdrop = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: ${props => (props.isOpen ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    background: rgba(51, 51, 51, 0.3);
    overflow: auto;
    z-index: 100;
    margin: 0 -1.5rem;

    @media only screen and (min-width: ${props => props.theme.tablet}) {
        margin: 0;
    }

    ${props => (props.fullScreenModal &&
        css`
            position: fixed;

            & > div {
                margin: 0 2.8rem;
            }
        `
    )}
`;

export const Modal = styled.div`
    position: relative;
    padding: 2.4rem;
    margin: 0 1.4rem;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 8px 16px rgba(61, 69, 67, 0.08);
`;
